import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useWidgetContainerSkeletonStyles } from './WidgetContainerSkeleton.styles';

export const WidgetContainerSkeleton = () => {
  const styles = useWidgetContainerSkeletonStyles();

  return (
    <section className={styles.root} aria-label="Loading widget">
      <Skeleton aria-label="Loading">
        <SkeletonItem className={styles.title} size={16} />
        <SkeletonItem className={styles.content} size={128} />
      </Skeleton>
    </section>
  );
};

WidgetContainerSkeleton.displayName = 'WidgetContainerSkeleton';
